/**
 * Raqam bir marta "sanaladi" (600 ms, ease-out): bosh sahifadagi katta ko'rsatkichlar uchun.
 * Keyingi o'zgarishlar (real-time yangilanish) ham eski qiymatdan yangisiga silliq o'tadi.
 * prefers-reduced-motion yoki yashirin tab -- darhol.
 */
import { useEffect, useRef, useState } from "react";

const DURATION = 600;

function reducedMotion(): boolean {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
}

export function useCountUp(target: number, duration = DURATION): number {
  const [value, setValue] = useState(target);
  const fromRef = useRef(target);
  const frame = useRef<number | null>(null);

  useEffect(() => {
    if (!Number.isFinite(target)) return;
    if (reducedMotion() || document.visibilityState === "hidden") {
      fromRef.current = target;
      setValue(target);
      return;
    }
    const from = fromRef.current;
    if (from === target) return;
    const start = performance.now();
    const step = (now: number) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const next = from + (target - from) * eased;
      setValue(p < 1 ? next : target);
      if (p < 1) frame.current = requestAnimationFrame(step);
      else fromRef.current = target;
    };
    frame.current = requestAnimationFrame(step);
    return () => {
      if (frame.current !== null) cancelAnimationFrame(frame.current);
      fromRef.current = target;
    };
  }, [target, duration]);

  return value;
}
